export default __webpack_public_path__ + "static/media/MBUZAI.5a8fcf32.png";